import { toast } from 'react-toastify';
import isObject from 'lodash/isObject';
import get from 'lodash/get';

const handleServerError2 = (error, options = {}) => {
  const { on422, on401, onElse } = options;
  if (!isObject(error))
    throw new Error('error [oject] is required as the first parameter');

  // options: {
  //   on422 [func] -> run this when we receive a 422 with response data
  //   on401 [func] -> run this when we receive a 401
  //   onElse [func] -> run this when it's some other type of error
  // }

  const status = get(error, ['response', 'status']);

  if (status === 401) {
    if (on401) {
      on401();
    } else {
      toast.error(
        "You aren't authorized to perform this action. Are you logged in? Try refreshing."
      );
    }
  } else if (status === 422) {
    if (on422) on422();
  } else {
    if (onElse) {
      onElse();
    } else {
      toast.error(
        'Whoops! Something went wrong. Please refresh and try again.'
      );
    }
  }
};

export default handleServerError2;
